export default __webpack_public_path__ + "static/media/EasyBank_FrontEnd_Mentor.3b391c6b.PNG";